export default [
  { label: 'Navy', value: 'Navy' },
  { label: 'Marine Corps', value: 'Marine Corps' },
  { label: 'Army', value: 'Army' },
  { label: 'Air Force', value: 'Air Force' }
]
